import { createContext as o, useContext as e } from "react";
import { a as t } from "../../../vanilla-CSAfDK5R.js";
const a = () => ({
  compactAtom: t(!1),
  contentStyleAtom: t(void 0)
}), m = o(a()), s = () => e(m);
export {
  m as ModalContext,
  a as createModalState,
  s as useModalStateAtoms
};
//# sourceMappingURL=index.js.map
